import { render } from "./ShowBool.vue?vue&type=template&id=1719a484"
import script from "./ShowBool.vue?vue&type=script&lang=js"
export * from "./ShowBool.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__